/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { MessageTemplate } from '../models/message-template';
import { EmailMessage } from '../models/email-message';
import { FormatMessage } from '../models/format-message';
@Injectable({
  providedIn: 'root',
})
class MessageTemplateService extends __BaseService {
  static readonly MessageTemplateCreateOrUpdatePath = '/api/MessageTemplate/CreateOrUpdate';
  static readonly MessageTemplateClonePath = '/api/MessageTemplate/Clone';
  static readonly MessageTemplateGetMessageTemplatePath = '/api/MessageTemplate/GetMessageTemplate';
  static readonly MessageTemplateFormatMessagePath = '/api/MessageTemplate/FormatMessage';
  static readonly MessageTemplateGetMessageTemplatesPath = '/api/MessageTemplate/GetMessageTemplates';
  static readonly MessageTemplateDeletePath = '/api/MessageTemplate/Delete/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param messageTemplate undefined
   */
  MessageTemplateCreateOrUpdateResponse(messageTemplate: MessageTemplate): __Observable<__StrictHttpResponse<MessageTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = messageTemplate;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/MessageTemplate/CreateOrUpdate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MessageTemplate>;
      })
    );
  }
  /**
   * @param messageTemplate undefined
   */
  MessageTemplateCreateOrUpdate(messageTemplate: MessageTemplate): __Observable<MessageTemplate> {
    return this.MessageTemplateCreateOrUpdateResponse(messageTemplate).pipe(
      __map(_r => _r.body as MessageTemplate)
    );
  }

  /**
   * @param params The `MessageTemplateService.MessageTemplateCloneParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `messageTemplateId`:
   */
  MessageTemplateCloneResponse(params: MessageTemplateService.MessageTemplateCloneParams): __Observable<__StrictHttpResponse<MessageTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.newName != null) __params = __params.set('newName', params.newName.toString());
    if (params.messageTemplateId != null) __params = __params.set('messageTemplateId', params.messageTemplateId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/MessageTemplate/Clone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MessageTemplate>;
      })
    );
  }
  /**
   * @param params The `MessageTemplateService.MessageTemplateCloneParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `messageTemplateId`:
   */
  MessageTemplateClone(params: MessageTemplateService.MessageTemplateCloneParams): __Observable<MessageTemplate> {
    return this.MessageTemplateCloneResponse(params).pipe(
      __map(_r => _r.body as MessageTemplate)
    );
  }

  /**
   * @param messageTemplateId undefined
   */
  MessageTemplateGetMessageTemplateResponse(messageTemplateId?: number): __Observable<__StrictHttpResponse<MessageTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (messageTemplateId != null) __params = __params.set('messageTemplateId', messageTemplateId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/MessageTemplate/GetMessageTemplate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MessageTemplate>;
      })
    );
  }
  /**
   * @param messageTemplateId undefined
   */
  MessageTemplateGetMessageTemplate(messageTemplateId?: number): __Observable<MessageTemplate> {
    return this.MessageTemplateGetMessageTemplateResponse(messageTemplateId).pipe(
      __map(_r => _r.body as MessageTemplate)
    );
  }

  /**
   * @param message undefined
   */
  MessageTemplateFormatMessageResponse(message: FormatMessage): __Observable<__StrictHttpResponse<EmailMessage>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = message;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/MessageTemplate/FormatMessage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EmailMessage>;
      })
    );
  }
  /**
   * @param message undefined
   */
  MessageTemplateFormatMessage(message: FormatMessage): __Observable<EmailMessage> {
    return this.MessageTemplateFormatMessageResponse(message).pipe(
      __map(_r => _r.body as EmailMessage)
    );
  }

  /**
   * @param customerId undefined
   */
  MessageTemplateGetMessageTemplatesResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<MessageTemplate>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/MessageTemplate/GetMessageTemplates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MessageTemplate>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  MessageTemplateGetMessageTemplates(customerId?: number): __Observable<Array<MessageTemplate>> {
    return this.MessageTemplateGetMessageTemplatesResponse(customerId).pipe(
      __map(_r => _r.body as Array<MessageTemplate>)
    );
  }

  /**
   * @param id undefined
   */
  MessageTemplateDeleteResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/MessageTemplate/Delete/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  MessageTemplateDelete(id: number): __Observable<Blob> {
    return this.MessageTemplateDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module MessageTemplateService {

  /**
   * Parameters for MessageTemplateClone
   */
  export interface MessageTemplateCloneParams {
    newName?: null | string;
    messageTemplateId?: number;
  }
}

export { MessageTemplateService }
